import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import {
  GetClaimClaimantResponse,
  GetClaimDetailResponse,
  GetClaimHandlerResponse,
  GetClaimHolderResponse,
  GetClaimPaymentsResponse,
  GetClaimsParams,
  GetClaimsResponse,
} from 'api/types/claims'

class Claims {
  // get claims list
  async getClaims(
    params: GetClaimsParams,
  ): Promise<GetClaimsResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimList}`

    const aditionalParams = []

    if (params.claimNo) {
      aditionalParams.push(`claimNo=${params.claimNo}`)
    }
    if (params.brokerNo) {
      aditionalParams.push(`brokerNo=${params.brokerNo}`)
    }
    if (params.policyNo) {
      aditionalParams.push(`policyNo=${params.policyNo}`)
    }
    if (params.status) {
      aditionalParams.push(`status=${params.status}`)
    }

    url += aditionalParams.length > 0 ? `?${aditionalParams.join('&')}` : ''

    return ApiProvider.getRequest(url) as Promise<
      GetClaimsResponse | (AxiosError | Error)
    >
  }

  async getClaimHandler(
    claimNo: number,
    brokerNo: number,
  ): Promise<GetClaimHandlerResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimHandler}?claimNo=${claimNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetClaimHandlerResponse | (AxiosError | Error)
    >
  }

  async getClaimHolder(
    claimNo: number,
    brokerNo: number,
  ): Promise<GetClaimHolderResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimHolder}?claimNo=${claimNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetClaimHolderResponse | (AxiosError | Error)
    >
  }

  async getClaimDetail(
    claimNo: number,
    brokerNo: number,
  ): Promise<GetClaimDetailResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimDetail}?claimNo=${claimNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetClaimDetailResponse | (AxiosError | Error)
    >
  }

  async getClaimClaimant(
    claimNo: number,
    brokerNo: number,
  ): Promise<GetClaimClaimantResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimClaimant}?claimNo=${claimNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetClaimClaimantResponse | (AxiosError | Error)
    >
  }

  async getClaimPayments(
    claimNo: number,
    brokerNo: number,
  ): Promise<GetClaimPaymentsResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimPayments}?claimNo=${claimNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetClaimPaymentsResponse | (AxiosError | Error)
    >
  }
}

export const claimsService = new Claims()
